export default "__VITE_ASSET__D2p$sKh9__"